export default __webpack_public_path__ + "static/media/app-download-logo.5cffb43f.jpg";